import { StudentIntelligentPropositionPage } from './StudentIntelligentPropositionPage';
export default StudentIntelligentPropositionPage;